import { Box } from "@mui/material";
import React from "react";
import EmbraceLogo from "../Common/EmbraceLogo";

const Header = () => {
  return (
    <Box
      component="header"
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 10,
        width: "100%",
        height: "4rem",
        borderBottom: "1px solid hsl(270 20% 90%)",
        backgroundColor: "hsl(0 0% 100% / 0.8)",
        backdropFilter: "blur(4px)",
        WebkitBackdropFilter: "blur(4px)",
        padding: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          height: "100%",
        }}
      >
        <EmbraceLogo sx={{ height: { xs: 40, md: 44 } }} />
      </Box>
    </Box>
  );
};

export default Header;
